/** 手机端 */

// 快递业务（快递员注册）
import courierApply from '@/components/PhonePage/courierBusiness/courierApply';//快递员申请
import courierStatus from '@/components/PhonePage/courierBusiness/courierStatus';//申请状态
import courierExamine from '@/components/PhonePage/courierBusiness/courierExamine';//审核申请

// 保密柜
import PrivacyCabinetPickUp from '@/components/PhonePage/PrivacyCabinet/PickUp'; //取件
import PrivacyCabinetPickUp2 from '@/components/PhonePage/PrivacyCabinet/PickUp2'; //取件

// 门禁预约
import RKEAppointmentApplyE from '@/components/PhonePage/RKEAppointment/AppointmentApplyE'; // 访客申请-体验
import RKEAppointmentApply from '@/components/PhonePage/RKEAppointment/AppointmentApply'; // 访客申请
import RKEAppointmentApplyCeshi from '@/components/PhonePage/RKEAppointment/AppointmentApply_ceshi'; // 访客申请
import RKEAppointmentCheck from '@/components/PhonePage/RKEAppointment/AppointmentCheck'; // 访客审核
import RKEAppointmentInform from '@/components/PhonePage/RKEAppointment/AppointmentInform'; // 操作通知

//小程序
import AppletShareDevice from '@/components/PhonePage/Applet/ShareDevice'; // 分享设备详情
import AppletCloudVideo from '@/components/PhonePage/Applet/CloudVideo'; // 云视频
import AppletFillInVisitorInfo from '@/components/PhonePage/Applet/FillInVisitorInfo'; // 待办事项-预约中心操作详情

//生产小工具小程序
import TAppletEARegister from '@/components/PhonePage/ToolApplet/EARegister'; // 设备激活

//生鲜柜
import FreshQRCode from '@/components/PhonePage/Fresh/QRCode'; // 二维码生成器


let rv = 0, psdWidth = 640, psdWidth750 = 750
let router = [
    //快递员提交申请
    {
        path: '/courierApply/',
        name: 'courierApply',
        component: courierApply,
        meta: {
            title: '快递员注册',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {
        path: '/courierStatus/',
        name: 'courierStatus',
        component: courierStatus,
        meta: {
            title: '快递员注册',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {
        path: '/courierExamine/',
        name: 'courierExamine',
        component: courierExamine,
        meta: {
            title: '快递员注册',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    // 保密柜
    {
        path: '/PhonePage/PrivacyCabinetPickUp/',
        name: 'PrivacyCabinetPickUp',
        component: PrivacyCabinetPickUp,
        meta: {
            title: '保密柜取件',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {
        path: '/PhonePage/PrivacyCabinetPickUp2/',
        name: 'PrivacyCabinetPickUp2',
        component: PrivacyCabinetPickUp2,
        meta: {
            title: '保密柜取件',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },

    /** 门禁预约 */
    {// 新增预约-体验
        path: '/PhonePage/RKEAppointmentApplyE',
        name: 'RKEAppointmentApplyE',
        component: RKEAppointmentApplyE,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {// 新增预约-重新预约-体验
        path: '/PhonePage/RKEAppointmentApplyE/:again',
        name: 'RKEAppointmentApplyE_again',
        component: RKEAppointmentApplyE,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },

    {// 新增预约
        path: '/PhonePage/RKEAppointmentApply/:aid',
        name: 'RKEAppointmentApply_aid',
        component: RKEAppointmentApply,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    
    { // 修改预约信息
        path: '/PhonePage/RKEAppointmentApply/:aid/edit/:id',
        name: 'RKEAppointmentApply',
        component: RKEAppointmentApply,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {// 新增预约
        path: '/PhonePage/RKEAppointmentApplyCeshi/:aid/appletShare/:user_id',
        name: 'RKEAppointmentApply_aid_user_id',
        component: RKEAppointmentApplyCeshi,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    { // 小程序分享
        path: '/PhonePage/RKEAppointmentApply/:aid/appletShare/:user_id',
        name: 'RKEAppointmentApply_aid_user_id',
        component: RKEAppointmentApply,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    { // 被访者审核预约信息
        path: '/PhonePage/RKEAppointmentCheck/:info',
        name: 'RKEAppointmentCheck',
        component: RKEAppointmentCheck,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },
    {
        path: '/PhonePage/AppointmentInform/:type',
        name: 'RKEAppointmentInform',
        component: RKEAppointmentInform,
        meta: {
            title: '智能人证查验预约系统',
            rv: rv,
            psdWidth: psdWidth,
            isPhonePage: true
        }
    },

    /** 极酷智控小程序 */
    { //分享设备详情
        path: '/PhonePage/AppletShareDevice/:device_type_code/:device_no_id/:box_number/:shareToken',
        name: 'AppletShareDevice',
        component: AppletShareDevice,
        meta: {
            title: '分享设备详情',
            rv: rv,
            psdWidth: psdWidth750,
            isPhonePage: true
        }
    },
    { // 云视频
        path: '/PhonePage/AppletCloudVideo',
        name: 'AppletCloudVideo',
        component: AppletCloudVideo,
        meta: {
            title: '云视频详情',
            rv: rv,
            psdWidth: psdWidth750,
            isPhonePage: true
        }
    },
    { // 待办事项-预约中心操作详情
        path: '/PhonePage/AppletFillInVisitorInfo/:id/:user_id',
        name: 'AppletFillInVisitorInfo',
        component: AppletFillInVisitorInfo,
        meta: {
            title: '详情',
            rv: rv,
            psdWidth: psdWidth750,
            isPhonePage: true
        }
    },
    

    /** 极酷生产工具小程序 */
    { //设备激活注册
        path: '/PhonePage/TAppletEARegister/:DeviceNoId',
        name: 'TAppletEARegister',
        component: TAppletEARegister,
        meta: {
            title: '设备激活注册',
            rv: rv,
            psdWidth: psdWidth750,
            isPhonePage: true
        }
    },

    /** 生鲜柜 */
    { //二维码生成器
        path: '/PhonePage/FreshQRCode',
        name: 'FreshQRCode',
        component: FreshQRCode,
        meta: {
            title: '二维码',
            rv: rv,
            psdWidth: psdWidth750,
            isPhonePage: true
        }
    },

]

export default router


// WEBPACK FOOTER //
// ./src/router/modules/PhonePage.js